export var mixin_pullupdown = ({
     data: function() {
        return {
            // par defaut à -1 pour que la condition dans
            // les composants soit toujours à false.
            // Sauf lors de l'ajout d'un nouvel élément dans les composants parents (item)
            // qui appellent la méthode showit()
            itemCollapseShow: -1
        }
    },
   
    methods: {
        showIt: function() {
            this.itemCollapseShow = this.modelObjects.length
        },
       
        pullUpItem: function(index) {
            // monte l'élement dans le tableau

            if (index > 0) {
                this.modelObjects.splice(index-1 , 0, this.modelObjects.splice(index, 1)[0]);
                // update display order des 2 elements modifiés
                var objup = this.modelObjects[index-1]
                var objdown = this.modelObjects[index]
                console.log('element qui est monté: ' + objup.title)
                console.log('element qui est descendu : ' + objdown.title)
                // update avec le bon "display_order"
                objup.display_order = index-1
                objdown.display_order = index
                this.updateModelObject(objup.id, objup)
                this.updateModelObject(objdown.id, objdown)
                // this.itemCollapseShow = objup.display_order
                }
            },
        pullDownItem: function(index) {
            // descend l'élement dans le tableau.
            if (index+1 <  this.modelObjects.length) {
                this.modelObjects.splice(index+1 , 0, this.modelObjects.splice(index, 1)[0]);
                // update display order des 2 elements modifiés
                var objup = this.modelObjects[index]
                var objdown = this.modelObjects[index+1]
                console.log('element qui est descendu : ' + objdown.title)
                console.log('element qui est monté: ' + objup.title)
                // update avec le bon "display_order"
                objup.display_order = index
                objdown.display_order = index+1
                this.updateModelObject(objup.id, objup)
                this.updateModelObject(objdown.id, objdown)
                // this.itemCollapseShow = objdown.display_order
            }
        },
    }



})